export function scrollIntoPage (options: ScrollIntoViewOptions = {}) {
  const page = document.getElementById('page')
  if (page) {
    page.scrollIntoView(options)
  }
}
